import React from "react";
import TableProgress from "../../../General/TableProgress"
import PieSkeleton from "../../../General/skeleton/PieSkeleton"
import TableSkeleton from "../../../General/skeleton/TableSkeleton"
import { audienceSpicificColumns } from "../../../../config/TableColumns.config";
import { formatNumber } from "../../../../utils/MainHelper";
import { audienceSpicificColors } from "../../../../config/Colors.config";
import RenderComponent from "../../../General/RenderComponent"
import PieChart from "../../../Charts/PieChart"
import CustomLayout from "../../../General/CustomLayout/CustomLayout";
import CustomTable from "../../../../customcomponents/customtable/CustomTable";

const columns = audienceSpicificColumns.map((col) => {
    switch (col.key) {
        case "score": return {
            ...col,
            render: (value, row) => (
                <TableProgress
                    value={value}
                    color={row.color}
                />
            )
        };
        case "share": return {
            ...col,
            render: (value) => formatNumber(value)
        };
        default: return col;
    }
});

function AudienceSpecificCategories({ data, loading = true }) {
    const NewData = data.map((item, idx) => ({
        ...item,
        color: audienceSpicificColors[idx],
        value: parseFloat((item.score * 100).toFixed(2)),
        name: item.item,
        type: item.item
    }));
    const header = (
        <div className="d-flex-col" style={{ width: "100%" }}>
            <b className="report--title">Audience Specific Categories</b>
            <p className="report--subtitle">This section displays specific categories the A.I. has identified as relevant to your target audience.</p>
        </div>
    );

    const pieContent = () => {
        if (loading) return <PieSkeleton />;
        if (!NewData.length) return <RenderComponent isFullscreen />;
        return <PieChart data={NewData} customColor />;
    };
    return (
        <CustomLayout
            className="report--audiencespecificcategory"
            classNameHeader="report--audiencespecificcategory--header"
            classNameBody="report--audiencespecificcategory--body d-flex flex-1 gap-1"
            style={{ width: "100%", height: "100%" }}
            header={header}
        >
            <div className="report--panel" style={{ width: "50%" }}>
                {pieContent()}
            </div>
            <div className="report--panel" style={{ width: "50%" }}>
                {!loading ? (
                    <CustomTable
                        style={{ height: "100%" }}
                        noCheckbox
                        pagination={false}
                        columns={columns}
                        dataSource={NewData}
                        numColProps={{ width: "40px" }}
                    />
                ) : <TableSkeleton numCols={3} />}
            </div>
        </CustomLayout>
    );
}

export default AudienceSpecificCategories;
